import React from "react";

import { useLocalization } from "@fluent/react";
import { Chip, Row } from "@narmi/design_system";

import { getConfidenceChip } from "../../confidence";
import { formatReceiptAmount, formatReceiptDate } from "../../format";

import styles from "./ReceiptDetailsDrawer.module.scss";

import type { ReceiptSuggestion } from "../../hooks/useReceipt";

interface SuggestedMatchCardProps {
  suggestion: ReceiptSuggestion;
  variant?: "suggested" | "matched";
}

const SuggestedMatchCard = ({
  suggestion,
  variant = "suggested",
}: SuggestedMatchCardProps) => {
  const { l10n } = useLocalization();
  const txn = suggestion.candidate_transaction;
  const confidence = getConfidenceChip(suggestion.confidence_score);
  const titleKey =
    variant === "matched"
      ? "receipts-drawer-matched-transaction"
      : "receipts-drawer-suggested-match";

  return (
    <div
      className={`${styles.card} border--all rounded--all--m padding--all--m`}
      data-testid="suggested-match-card"
    >
      <p className="nds-typescale--upper fontColor--secondary fontWeight--bold fontSize--xs">
        {l10n.getString(titleKey)}
      </p>
      <div className="margin--top--s">
        <Row justifyContent="space-between" alignItems="center">
          <Row.Item>
            <div className="fontWeight--semibold">
              {txn.description || txn.merchant}
            </div>
          </Row.Item>
          <Row.Item shrink>
            <div className="fontWeight--semibold">
              {formatReceiptAmount(txn.amount)}
            </div>
          </Row.Item>
        </Row>
        <Row justifyContent="space-between" alignItems="center">
          <Row.Item>
            <div className="fontColor--secondary fontSize--s">
              {formatReceiptDate(txn.datetime)}
              {txn.description && txn.merchant && ` · ${txn.merchant}`}
            </div>
          </Row.Item>
          <Row.Item shrink>
            <Chip
              kind={confidence.kind}
              label={l10n.getString(confidence.labelKey)}
            />
          </Row.Item>
        </Row>
      </div>
    </div>
  );
};

export default SuggestedMatchCard;
